import * as Sentry from '@sentry/vue'

/**
 * Log an enhanced error to Sentry. This results in request errors for individual endpoints being given their own
 * issue in Sentry, rather than being grouped in generic 'Network Error' issues.
 *
 * @param {Error} error The error object from the failed request.
 * @param {number[]} [excludedStatusCodes] If not provided, status codes 400-404 are excluded.
 * @param {string} [errorMessageText] If not provided, the error message is `Request to
 * ${error.request.responseURL} failed with status code ${error.response.status}`
 */
export function sendEnhancedErrorToSentry(error, excludedStatusCodes = [400, 401, 402, 403, 404], errorMessageText) {
  if (!excludedStatusCodes.includes(error?.request?.status) && error?.request?.responseURL && error?.response?.status) {
    if (!errorMessageText) {
      errorMessageText = `Request to ${error.request.responseURL} failed with status code ${error.response.status}`
    }

    const enhancedError = new Error(errorMessageText, { cause: error })
    Sentry.captureException(enhancedError)
  }
}
